import {
    fa1,
    fa3,
    fa6,
    faPause,
    faXmark,
} from "@fortawesome/pro-solid-svg-icons";

export const initialServerActivations = [
    {
        id: "pending",
        title: "In sospeso",
        color: "brand",
        icon: faPause,
        value: 0,
    },
    {
        id: "lastSixMonths",
        title: "Ultimi 6 mesi",
        color: "primary",
        icon: fa6,
        value: 0,
        months: 6,
    },
    {
        id: "lastYear",
        title: "Ultimo anno",
        color: "primary",
        icon: fa1,
        value: 0,
        years: 1,
    },
];

export const initialLicenses = [
    {
        id: "expired",
        title: "Scadute",
        color: "brand",
        icon: faXmark,
        value: 0,
    },
    {
        id: "expiringThreeMonths",
        title: "In Scadenza",
        color: "primary",
        icon: fa3,
        value: 0,
        months: 3,
    },
    {
        id: "expiringSixMonths",
        title: "In Scadenza",
        color: "primary",
        icon: fa6,
        value: 0,
        months: 6,
    },
];
